module.exports = "/_next/static/images/37ddcbd01b0b5ba1eabd0e62bfbb1b1e-cajitas-right-mobile.jpg";